import { defineMessages } from 'react-intl-next';

export const messages: {
	closeButton: {
		defaultMessage: string;
		id: string;
	};
	contactSupportButton: {
		defaultMessage: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		id: string;
	};
	errorIconAlt: {
		defaultMessage: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'twc.xflow.modal.error.heading',
		defaultMessage: 'Looks like something went wrong',
	},
	description: {
		id: 'twc.xflow.modal.error.description',
		defaultMessage:
			"We weren't able to start your trial. Try again later or contact our support team.",
	},
	closeButton: {
		id: 'twc.xflow.modal.error.close.button',
		defaultMessage: 'Close',
	},
	contactSupportButton: {
		id: 'twc.xflow.modal.error.contact.support.button',
		defaultMessage: 'Contact support',
	},
	errorIconAlt: {
		id: 'twc.xflow.modal.error.icon.alt',
		defaultMessage: 'Error icon',
	},
});
